<template>
    <v-footer app  class="footerpart" inset>
      <v-col cols="12">
        <span>© {{ new Date().getFullYear() }} — S2S Internet</span>
        <!-- <v-s></v-spacer> -->
        <!-- <v-divider></v-divider> -->
        <!-- <span >asd</span> -->
      </v-col>
    </v-footer>
</template>
<script>
export default {
    name: "Footer",
}
</script>
<style lang="scss">
  .v-application .footerpart{
    border-top:1px solid rgba(0,0,0,0.1)!important;
  }
</style>